<script lang="ts">
  import { createContext } from 'reka-ui'
  import { type Ref } from 'vue'

  export interface RadioGroupContext {
    modelValue: Ref<string | boolean | undefined>
    disabled: boolean
  }

  export type RadioGroupModelValue = string | boolean | undefined

  const [_useRadioGroup, provideRadioGroup] = createContext<{
    modelValue: Ref<RadioGroupModelValue>
    disabled: Ref<boolean>
  }>('gs-radio-group')

  export function useRadioGroup() {
    return _useRadioGroup()
  }
</script>
<script setup lang="ts">
  const modelValue = defineModel<RadioGroupModelValue>('modelValue', {
    required: true
  })

  const disabled = defineModel<boolean>('disabled', {
    default: false
  })

  provideRadioGroup({
    modelValue,
    disabled
  })
</script>

<template>
  <slot />
</template>
